import React from 'react';
import { PageSection } from 'adc-ui-components';

import { PREACTIVE_SVG } from '../helpers/preactive';

const PreactiveBanner = ({ details = {} }) => (
  <PageSection className="ui-grey">
    <div className="preactive-no-devices">
      <div>
        <h1 className="heading2" tabIndex="-1">{details.text}</h1>
        <span className="color--cool-grey8">In the meantime, you can prepare for installation.</span>
        <br />
        <br />
        {details.link && (
          <a href={details.link}>Prepare for Installation</a>
        )}
      </div>
      <img width="100%" src={PREACTIVE_SVG} alt="" />
    </div>
  </PageSection>
);

export default PreactiveBanner;
